/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withTranslation } from 'react-i18next';
import { Fab } from '@material-ui/core';

import { formValidator } from '../../../AppUtil/AppUtil';
import { commonStyleForEditPersonalInfo } from '../../Common/CommonStyle';
import BaseForm from './BaseForm';
import PageHeaderTitle from '../../Common/Profile/PageHeaderTitle';
import { useMediaQuery } from 'react-responsive';
import { IIFC } from 'react-iifc';
import MobileFooter from '../../Common/Profile/MobileFooter';
import InputLabelMobile from '../../Common/Profile/InputLabelMobile';
import { hot } from 'react-hot-loader';
const { MOBILE } = window.AppConfig.SCREEN_SIZE;

class CashOutAmountForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			_cashOutAmountForm: {
				amount: {
					value: '',
					placeholder: 'Amount',
					isValid: true,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'Amount is required'
						}
					},
					error_text: ''
				}
			}
		};
	}

	handleInputChange = e => {
		this.setState({
			_disableSaveButton: false
		});
		const name = e.target.name;
		const value = e.target.value;

		const cashOutAmountForm = {
			...this.state._cashOutAmountForm
		};
		const updatedFormElement = {
			...cashOutAmountForm[name]
		};
		updatedFormElement.value = value;
		updatedFormElement.isValid = true;
		updatedFormElement.error_text = '';
		cashOutAmountForm[name] = updatedFormElement;

		this.setState({
			_cashOutAmountForm: cashOutAmountForm
		});
	};

	formValidator = () => {
		const form = {
			...this.state._cashOutAmountForm
		};
		let [updatedForm, isFormValid] = formValidator(form);
		if (Number(updatedForm.amount.value) <= 0) {
			isFormValid = false;
			updatedForm.amount.isValid = false;
			updatedForm.amount.error_text = 'The amount must be greater than zero';
		}
		this.setState({
			_cashOutAmountForm: updatedForm
		});
		return isFormValid;
	};

	onSubmitHandler = e => {
		e.preventDefault();
		if (!this.formValidator()) {
			return false;
		}

		const cashOutAmountForm = {
			...this.state._cashOutAmountForm
		};
		const cashOutObj = {
			amount: +cashOutAmountForm.amount.value
		};
		this.props.onAmountSubmit(cashOutObj);
	};

	render() {
		const { classes, t, isLoading, closeProfileScreen } = this.props;
		const { _cashOutAmountForm } = this.state;

		const newValue = _cashOutAmountForm.amount.value.toString().replace(/,/g, '');

		const finalValue = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		return (
			<IIFC>
				{() => {
					const isMobile = useMediaQuery({ query: `(max-width: ${MOBILE})` });
					return (
						<BaseForm closeProfileScreen={closeProfileScreen} isLoading={isLoading}>
							<Grid alignItems="center" item justify="center" sm={12} xs={12}>
								<Typography className="subtitle" component="h1" variant="h5">
									{t('profile.cash_out')}
								</Typography>
								{/* {isMobile && (
									<p className="excluding_fees">
										Enter amount to cash out excluding fees <br /> <span>(P20 for OTC)</span>
									</p>
								)} */}
							</Grid>
							<Grid alignItems="center" item justify="center" sm={12} xs={12}>
								<InputLabelMobile label="Amount*" />
								<TextField
									autoComplete="amount"
									className={classes.displayFlex}
									error={!_cashOutAmountForm.amount.isValid && _cashOutAmountForm.amount.isTouched}
									fullWidth
									helperText={
										!_cashOutAmountForm.amount.isValid && _cashOutAmountForm.amount.isTouched
											? t(_cashOutAmountForm.amount.error_text)
											: ''
									}
									id="amount"
									label={isMobile ? null : 'Amount'}
									placeholder={isMobile ? 'Amount' : null}
									name="amount"
									onChange={this.handleInputChange}
									required
									type="text"
									value={finalValue}
									variant="outlined"
								/>
							</Grid>
							{isMobile ? null : (
								<Grid alignItems="center" item justify="center" sm={12} xs={12}>
									<div className={classes.blockdiv}>
										<Fab
											aria-label="add"
											className={classes.submit}
											color="primary"
											onClick={this.onSubmitHandler}
											disabled={this.props.disabled}
											size="medium"
											type="submit"
											variant="extended">
											Next &nbsp;
										</Fab>
									</div>
								</Grid>
							)}
							<MobileFooter
								className="mt-158"
								onClick={this.props.closeProfileScreen}
								hasNext={true}
								onSubmit={this.onSubmitHandler}
								disabled={this.props.disabled}
							/>
						</BaseForm>
					);
				}}
			</IIFC>
		);
	}
}

export default hot(module)(withStyles(commonStyleForEditPersonalInfo)(withTranslation()(CashOutAmountForm)));
